import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Input from "components/Elements/Input";
// import Select from "components/Elements/Select";
import Select from "react-select";
import { saveUser, getUser } from "actions/users";
import { getClients } from "actions/clients";
import styled from "styled-components";
// components
import Sidebar from "components/Sidebar/Sidebar.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";

export const ErrorField = styled.span`
  color: red;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

export const User = ({ navigation }) => {
  const navigate = useNavigate();
  const { user_id } = useParams();
  const dispatch = useDispatch();
  const { user, savedUser, saving } = useSelector((state) => state.users);
  const { clients } = useSelector((state) => state.clients);
  const [localUser, setLocalUser] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [clientOptions, setClientOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  console.log("USER_ID: ", user_id);
  console.log("USER: ", user);
  console.log("SAVED USER: ", savedUser);
  console.log("CLIENTS: ", clients);

  const userTypes = [
    { label: "admin", value: "admin" },
    { label: "manager", value: "manager" },
    { label: "user", value: "user" },
    { label: "client admin", value: "client admin" },
  ];

  const compedOptions = [
    { label: "False", value: false },
    { label: "True", value: true },
  ];

  useEffect(() => {
    if (!clients) {
      dispatch(getClients());
    }

    if (user_id && (user === null || localUser === null)) {
      setLoading(true);
      dispatch(getUser(user_id));
    } else if (!user_id) {
      setLoading(false);
      setLocalUser(null);
    }

    return () => {
      setLocalUser(null);
      setLoading(true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user_id) {
      setLoading(true);
      dispatch(getUser(user_id));
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id]);

  useEffect(() => {
    if (clients) {
      setClientOptions(
        clients.map((client) => {
          return { label: client.name, value: client.id };
        })
      );
    }
  }, [clients]);

  useEffect(() => {
    if (user) {
      // } && user_id === user.public_id) {
      setLoading(false);
      setLocalUser({ ...user });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (loading) {
    return (
      <>
        <Sidebar {...sidebar} />
        <div
          className="relative md:ml-64 bg-blueGray-100 pt-24"
          style={{ height: "100%", minHeight: "100vh" }}
        >
          <div style={{ marginLeft: "50px" }}>Loading User...</div>
        </div>
      </>
    );
  }

  const handleChange = ({ target }) => {
    const u = { ...localUser };
    u[target.name] = target.value;
    setLocalUser(u);
  };

  const handleUserTypeChange = (userType) => {
    const u = { ...localUser };
    u.user_type = userType.value;
    setLocalUser(u);
  };

  const handleCompedChange = (comped) => {
    const u = { ...localUser };
    u.comped_subscription = comped.value;
    setLocalUser(u);
  };

  const handleClientChange = (client) => {
    const u = { ...localUser };
    u.client = { public_id: client.value, name: client.label };
    setLocalUser(u);
  };

  const validateFields = () => {
    setFormErrors({});
    const errors = {};

    const emailValid =
      localUser?.email &&
      localUser?.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    errors.email = emailValid ? "" : " is invalid";
    /*
    const passwordValid =
        (localUser?.public_id && localUser.password.length === 0) ||
      (localUser?.password && localUser.password.length >= 8);
    errors.password = passwordValid ? "" : " is too short";
      */
    const firstNameValid =
      localUser?.firstname && localUser.firstname.length > 0;
    errors.firstName = firstNameValid ? "" : " is required";
    const lastNameValid = localUser?.lastname && localUser.lastname.length > 0;
    errors.lastName = lastNameValid ? "" : " is required";

    console.log("errors: ", errors);
    setFormErrors(errors);

    //return emailValid && passwordValid && firstNameValid && lastNameValid;
    return emailValid && firstNameValid && lastNameValid;
  };

  const save = () => {
    console.log("save user: ", localUser);
    if (validateFields()) {
      dispatch(saveUser(localUser));
    }
  };

  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-24">
          <div>
            <div className="relative p-6 flex-auto ">
              <div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/admin/users");
                  }}
                >
                  <i className="fa fa-arrow-left" /> Back to Users
                </div>{" "}
              </div>
              <h3 className="text-3xl font-semibold">
                {localUser?.id ? "Edit User" : "Add User"}
              </h3>
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <label>ID</label>
                <Input
                  label="ID"
                  placeholder="ID"
                  name="id"
                  value={localUser?.id ?? ""}
                  disabled
                />
                <label>Public ID</label>
                <Input
                  label="Public ID"
                  placeholder="Public ID"
                  name="public_id"
                  value={localUser?.public_id ?? ""}
                  disabled
                />
                <label>
                  First Name <ErrorField>{formErrors.firstName}</ErrorField>
                </label>
                <Input
                  label="First Name"
                  placeholder="First Name"
                  name="firstname"
                  value={localUser?.firstname ?? ""}
                  onChange={handleChange}
                />
                <label>
                  Last Name <ErrorField>{formErrors.lastName}</ErrorField>
                </label>
                <Input
                  label="Last Name"
                  placeholder="Last Name"
                  name="lastname"
                  value={localUser?.lastname ?? ""}
                  onChange={handleChange}
                />
                <label>
                  Email <ErrorField>{formErrors.email}</ErrorField>
                </label>
                <Input
                  label="Email"
                  placeholder="Email"
                  name="email"
                  value={localUser?.email ?? ""}
                  onChange={handleChange}
                />
                <label>
                  Client <ErrorField>{formErrors.client}</ErrorField>
                </label>
                <Select
                  label="Client"
                  placeholder="Client"
                  name="client"
                  value={
                    localUser?.client !== null
                      ? clientOptions.find(
                          (c) =>
                            localUser?.client &&
                            c.value === localUser?.client.id
                        )
                      : null
                  }
                  options={clientOptions}
                  onChange={handleClientChange}
                />
                <label>
                  User Type <ErrorField>{formErrors.userType}</ErrorField>
                </label>
                <Select
                  label="User Type"
                  placeholder="User Type"
                  name="user_type"
                  value={
                    localUser?.user_type
                      ? {
                          label: localUser?.user_type,
                          value: localUser?.user_type,
                        }
                      : null
                  }
                  options={userTypes}
                  onChange={handleUserTypeChange}
                />
                <label>
                  Password <ErrorField>{formErrors.password}</ErrorField>
                </label>
                <Input
                  type="password"
                  autoComplete="new-password"
                  label="Password"
                  name="password"
                  placeholder="Password"
                  value={localUser?.password ?? ""}
                  onChange={handleChange}
                />
                <label>Comped Subscription</label>
                <Select
                  label="Comped Subscription"
                  placeholder="Comped Subscription"
                  name="comped_subscription"
                  value={
                    localUser?.comped_subscription
                      ? {
                          label: "True",
                          value: true,
                        }
                      : {
                          label: "False",
                          value: false,
                        }
                  }
                  options={compedOptions}
                  onChange={handleCompedChange}
                />
              </div>
            </div>
            <div className="relative p-6 flex-auto"></div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={save}
                disabled={saving}
              >
                {saving ? (
                  <>
                    <i className="fas fa-circle-notch fa-spin"></i> Saving...
                  </>
                ) : (
                  <>Save Changes</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default User;
